import Header from "./components/Header";
import SectionOne from "./components/SectionOne";
import SectionTwo from "./components/SectionTwo";
import SectionThree from "./components/SectionThree";
import SectionWeather from "./components/SectionWeather";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Header />
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionWeather />
      <Footer />
    </>
  );
}

export default App;
